module.exports = __webpack_public_path__ + "img/versapay-overview-6.22cec84a.png";